import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { EducationalOrganizationsOptimizedDTO } from '../types';

interface OrganizationsStore {
    organizations: EducationalOrganizationsOptimizedDTO[];
    isLoading: boolean;
    error: string | null;
    setOrganizations: (data: EducationalOrganizationsOptimizedDTO[]) => void;
    setLoading: (isLoading: boolean) => void;
    setError: (error: null | string) => void;
    getOrganizationsByIds: (ids: string[]) => EducationalOrganizationsOptimizedDTO[] | undefined;
}

export const useOrganizationsStore = create<OrganizationsStore>()(
    devtools((set, get) => ({
        organizations: [],
        isLoading: true,
        error: null,
        setOrganizations: (data) => set({ organizations: data }),
        getOrganizationsByIds: (ids) => {
            return get().organizations.filter(org => {
                return ids.some(id => id === org.id);
            });
        },
        setLoading: (isLoading: boolean) => set({ isLoading }),
        setError: (error: string | null) => set({ error }),
    }))
);